import axiosInstance from '../../../../utils/axiosInstance';

// =============================================
// MERCHANTS
// =============================================

export const getMerchants = async () => {
  const { data } = await axiosInstance.get('/merchants/');
  return data;
};

export const getMerchantById = async (merchantId) => {
  const { data } = await axiosInstance.get(`/merchants/${merchantId}/`);
  return data;
};

export const createMerchant = async (merchantData) => {
  const { data } = await axiosInstance.post('/merchants/', merchantData);
  return data;
};

export const updateMerchant = async (merchantId, merchantData) => {
  const { data } = await axiosInstance.put(`/merchants/${merchantId}/`, merchantData);
  return data;
};

export const deleteMerchant = async (merchantId) => {
  const { data } = await axiosInstance.delete(`/merchants/${merchantId}/`);
  return data;
};

export const bulkCreateMerchants = async (merchants) => {
  const { data } = await axiosInstance.post('/merchants/bulk/', { merchants });
  return data;
};

// =============================================
// MERCHANT LOGIN DETAILS
// =============================================

export const getMerchantLoginDetails = async (merchantId) => {
  const { data } = await axiosInstance.get(`/merchants/${merchantId}/login-details/`);
  return data;
};

// =============================================
// ASSISTANTS
// =============================================

export const createAssistant = async (merchantId, assistantData) => {
  const { data } = await axiosInstance.post(`/merchants/${merchantId}/assistants/`, assistantData);
  return data;
};

export const deleteAssistant = async (merchantId, assistantId) => {
  const { data } = await axiosInstance.delete(`/merchants/${merchantId}/assistants/${assistantId}/`);
  return data;
};

export const getAssistantLoginDetails = async (merchantId, assistantId) => {
  const { data } = await axiosInstance.get(`/merchants/${merchantId}/assistants/${assistantId}/login-details/`);
  return data;
};

// =============================================
// BULK MERCHANT ASSIGNMENT REPLACEMENT
// =============================================

// Reassigns all contracts from one merchant to another in a single operation.
// Returns { replaced_count, from_merchant, to_merchant }
export const bulkReplaceMerchant = async (fromMerchantId, toMerchantId) => {
  const { data } = await axiosInstance.post('/merchants/bulk-replace/', {
    from_merchant_id: fromMerchantId,
    to_merchant_id: toMerchantId,
  });
  return data;
};
